export default __webpack_public_path__ + "static/media/LEVEL5.ff4152a6.png";